import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaArrowRight,
  FaBrain,
  FaWifi,
  FaCode,
  FaCloud,
  FaShieldAlt,
  FaChartLine,
} from 'react-icons/fa';
import logo from '../../assets/logo-main.svg';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'AI & Generative AI', icon: <FaBrain />, to: '/#services' },
    { name: 'IoT & Smart Systems', icon: <FaWifi />, to: '/#services' },
    { name: 'Web & App Development', icon: <FaCode />, to: '/#services' },
    { name: 'Cloud & DevOps', icon: <FaCloud />, to: '/#services' },
    { name: 'Cybersecurity', icon: <FaShieldAlt />, to: '/#services' },
    { name: 'Data Intelligence', icon: <FaChartLine />, to: '/#services' },
  ];

  const quickLinks = [
    { name: 'Home', to: '/' },
    { name: 'Services', to: '/#services' },
    { name: 'Product', to: '/products' },
    { name: 'Contact', to: '/#contact' },
  ];

  const socials = [
    { name: 'Facebook',  icon: <FaFacebook />,  url: 'https://facebook.com/abidottsolutions' },
    { name: 'Twitter',   icon: <FaTwitter />,   url: 'https://twitter.com/abidottsolutions' },
    { name: 'LinkedIn',  icon: <FaLinkedin />,  url: 'https://linkedin.com/company/abidott-solutions' },
    { name: 'Instagram', icon: <FaInstagram />, url: 'https://instagram.com/abidottsolutions' },
  ];

  return (
    <footer className="footer">
      <div className="footer-glow" />

      <div className="container">
        {/* Top section */}
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Abidott Solutions home">
              <img src={logo} alt="Abidott Solutions" className="footer-logo-img" />
            </Link>
            <p className="footer-tagline">
              AI-driven IT solutions for businesses that want to grow fast, operate smart, and stay secure.
            </p>
            <div className="footer-socials">
              {socials.map((s, i) => (
                <a key={i} href={s.url} className="footer-social" aria-label={s.name}
                   target="_blank" rel="noopener noreferrer">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4 className="footer-col-title">Our Services</h4>
            <ul className="footer-list">
              {services.map((s, i) => (
                <li key={i}>
                  <Link to={s.to} className="footer-service-link">
                    <span className="fs-icon">{s.icon}</span>
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul className="footer-list">
              {quickLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.to} className="footer-link">
                    <FaArrowRight className="fl-icon" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4 className="footer-col-title">Contact Us</h4>
            <div className="footer-contact">
              <a href="tel:+919207450908" className="footer-contact-item">
                <FaPhone className="fci-icon" />
                <div>
                  <span className="fci-label">Phone</span>
                  <span className="fci-value">+91 92074 50908</span>
                </div>
              </a>
              <a href="mailto:info@abidottsolutions.com" className="footer-contact-item">
                <FaEnvelope className="fci-icon" />
                <div>
                  <span className="fci-label">Email</span>
                  <span className="fci-value">info@abidottsolutions.com</span>
                </div>
              </a>
              <div className="footer-contact-item">
                <FaMapMarkerAlt className="fci-icon" />
                <div>
                  <span className="fci-label">Address</span>
                  <span className="fci-value">Muvattupuzha, Kerala — 686669, India</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter */}
        <div className="footer-newsletter">
          <div className="fn-text">
            <h4>Stay Ahead of the Curve</h4>
            <p>Subscribe for the latest in AI, IoT, and technology insights — delivered monthly.</p>
          </div>
          <div className="fn-form">
            <input type="email" placeholder="Enter your email address" className="fn-input" />
            <button className="fn-btn">
              Subscribe <FaArrowRight className="btn-icon" />
            </button>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © {currentYear} Abidott Solutions OPC Pvt Limited. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <Link to="/#contact" className="fbl-link">Privacy Policy</Link>
            <Link to="/#contact" className="fbl-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
